export default {
  state: {
    documentsSearchResults: [
      {
        fileType: 'pdf',
        documentsType: 'policy',
        title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
        date: `${new Date().getDate()}/${
          new Date().getMonth() + 1
        }/${new Date().getFullYear()}`,
        downloadDocumentLink: 'test',
        tags: ['Tag name', 'Tag name', 'Tag name'],
        sections: [
          {
            sectionName: 'Seaction name',
            pages: 36,
            matchScore: 'Best match',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          },
          {
            sectionName: 'Seaction name',
            pages: 36,
            matchScore: 'Best match',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          },
          {
            sectionName: 'Seaction name',
            pages: 36,
            matchScore: 'Best match',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          },
          {
            sectionName: 'Seaction name',
            pages: 36,
            matchScore: 'Best match',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          },
        ],
      },
      {
        fileType: 'pdf',
        documentsType: 'policy',
        title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
        date: `${new Date().getDate()}/${
          new Date().getMonth() + 1
        }/${new Date().getFullYear()}`,
        downloadDocumentLink: 'test',
        tags: ['Tag name', 'Tag name', 'Tag name'],
        sections: [
          {
            sectionName: 'Seaction name',
            pages: 36,
            matchScore: 'Best match',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          },
          {
            sectionName: 'Seaction name',
            pages: 36,
            matchScore: 'Best match',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          },
          {
            sectionName: 'Seaction name',
            pages: 36,
            matchScore: 'Best match',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          },
          {
            sectionName: 'Seaction name',
            pages: 36,
            matchScore: 'Best match',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          },
        ],
      },
    ],
    evidencesResults: [],
    answerGeneration:{},
    loadingEvidence: false,
    loadingAiGeneration: false,
    searchLoaderProgress: '',
  },
  mutations: {
    SET_DOCUMENT_SEARCH_RESULTS(state, value) {
      console.log('Inside SET_DOCUMENT_SEARCH_RESULTS - value', value)
      state.documentsSearchResults = value
    },
    SET_LOADING_AI_GENERATION(state, value) {
      console.log('Inside SET_LOADING_AI_GENERATION - value', value)
      state.loadingAiGeneration = value
    },
    SET_EVIDENCE_LOADING(state, value) {
      console.log('Inside SET_EVIDENCE_LOADING - value', value)
      state.loadingEvidence = value
    },
    SET_EVIDENCES_RESULTS(state, value) {
      console.log('Inside SET_EVIDENCES_RESULTS - value', value)
      state.evidencesResults = value
    },
    SET_ANSWERS_GENERATED(state, value) {
      console.log('Inside SET_ANSWERS_GENERATED - value', value)
      state.answerGeneration = value
    },
    SET_SEARCH_LOADER_PROGRESS(state, value) {
      console.log('Inside SET_SEARCH_LOADER_PROGRESS - value', value)
      state.searchLoaderProgress = value
    },
  },
  getters: {
    GET_ANSWERS_GENERATED(state) {
      return state.answerGeneration
    },
    GET_EVIDENCES_RESULTS(state) {
      return state.evidencesResults
    },
    GET_EVIDENCE_LOADING(state) {
      return state.loadingEvidence
    },
    GET_LOADING_AI_GENERATION(state) {
      return state.loadingAiGeneration
    },
    GET_DOCUMENT_SEARCH_RESULTS(state) {
      return state.documentsSearchResults
    },
    GET_SEARCH_LOADER_PROGRESS(state) {
      return state.searchLoaderProgress
    },
  },
}
